/* FadCloset — product.js : variant selection, gallery, stock messaging */
(function () {
  'use strict';

  var root = document.querySelector('[data-product-root]');
  if (!root) return;

  var json = document.querySelector('[data-product-json]');
  var variants = json ? JSON.parse(json.textContent) : [];

  var form = root.querySelector('[data-product-form]');
  var idInput = root.querySelector('[data-variant-id]');
  var priceEl = root.querySelector('[data-price]');
  var compareEl = root.querySelector('[data-compare]');
  var addBtn = root.querySelector('[data-add-button]');
  var addText = root.querySelector('[data-add-text]');
  var stockLine = root.querySelector('[data-stock-line]');
  var bridge = root.querySelector('[data-bridge]');

  var customPanel = root.querySelector('[data-custom-panel]');
  var customCategory = customPanel ? customPanel.dataset.customCategory : null;
  var customGender = customPanel ? customPanel.dataset.customGender : null;
  var customConsent = root.querySelector('[data-custom-consent]');
  var customError = root.querySelector('[data-custom-error]');
  var customPropSpec = root.querySelector('[data-custom-prop-spec]');
  var customMeasureInputs = customPanel ? Array.prototype.slice.call(customPanel.querySelectorAll('[data-measure-input]')) : [];
  var customQs = customPanel ? Array.prototype.slice.call(customPanel.querySelectorAll('[data-q]')) : [];
  var customRequired = customPanel ? Array.prototype.slice.call(customPanel.querySelectorAll('[data-custom-required]')) : [];
  var customFitNote = customPanel ? customPanel.querySelector('[data-fit-note]') : null;

  var FIT_DIFFERENTIALS = {
    mens: {
      Slim: { chest: 2.0, waist: 4.0 },
      Regular: { chest: 3.0, waist: 5.0 },
      Loose: { chest: 4.5, waist: 6.5 }
    },
    womens: {
      Slim: { bust: 2.0, waist: 3.0, hips: 1.0 },
      Regular: { bust: 3.0, waist: 4.0, hips: 1.0 },
      Loose: { bust: 4.0, waist: 5.0, hips: 2.0 }
    }
  };

  function updateFitNote() {
    if (!customFitNote) return;
    var checked = customPanel.querySelector('[data-label="Preferred fit"]:checked');
    var fit = checked ? checked.value : 'Regular';
    var d = FIT_DIFFERENTIALS[customGender] && FIT_DIFFERENTIALS[customGender][fit];
    if (!d) return;
    customFitNote.textContent = customGender === 'womens'
      ? fit + ' fit adds ' + d.bust + '" at the bust, ' + d.waist + '" at the waist, and ' + d.hips + '" at the hips over your body measurements — so measure snug, with no wiggle room.'
      : fit + ' fit adds ' + d.chest + '" at the chest and ' + d.waist + '" at the waist over your body measurements — so measure snug, with no wiggle room.';
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function selectedOptions() {
    var checked = root.querySelectorAll('input[type="radio"][data-option-index]:checked');
    return Array.prototype.map.call(checked, function (i) { return i.value; });
  }

  function match(options) {
    return variants.find(function (v) {
      return options.every(function (val, i) { return v.options[i] === val; });
    });
  }

  /* ---------- custom size: reuses the same category measurement panels as the builder ---------- */
  var SPEC_KEY = 'fadcloset:spec';

  function readSpec() {
    try { return JSON.parse(localStorage.getItem(SPEC_KEY)) || {}; }
    catch (e) { return {}; }
  }

  function writeSpec() {
    if (!customPanel) return;
    var profile = {};
    customQs.forEach(function (q) {
      if (q.type === 'radio') { if (q.checked) profile[q.dataset.label] = q.value; }
      else if (q.value) { profile[q.dataset.label] = q.value; }
    });
    var spec = { category: customCategory, measures: {}, profile: profile, savedAt: Date.now() };
    customMeasureInputs.forEach(function (i) { if (i.value) spec.measures[i.dataset.num] = i.value; });
    try { localStorage.setItem(SPEC_KEY, JSON.stringify(spec)); } catch (e) { /* private mode */ }
  }

  function applySpec() {
    if (!customPanel) return;
    var spec = readSpec();
    if (spec.category !== customCategory) return;
    if (spec.measures) {
      customMeasureInputs.forEach(function (i) {
        var v = spec.measures[i.dataset.num];
        if (v) i.value = v;
      });
    }
    if (spec.profile) {
      customQs.forEach(function (q) {
        var v = spec.profile[q.dataset.label];
        if (!v) return;
        if (q.type === 'radio') { if (q.value === v) q.checked = true; }
        else { q.value = v; }
      });
    }
  }

  function isCustomSelected() {
    return selectedOptions().some(function (v) { return v.trim().toLowerCase() === 'custom'; });
  }

  function customAdvisories() {
    var notes = [];
    var get = function (code) {
      var f = customMeasureInputs.find(function (i) { return i.dataset.short === code; });
      return f && f.value ? parseFloat(f.value) : null;
    };
    var slvR = get('SLV R'), slvL = get('SLV L');
    if (slvR && slvL && Math.abs(slvR - slvL) > 2) notes.push('Sleeves differ by more than 2 inches — worth re-checking.');
    var chest = get('CHEST') || get('BUST'), waist = get('WAIST');
    if (chest && waist && waist > chest + 12) notes.push('Waist is much larger than chest — re-check the tape is level.');
    var shoulder = get('SHLDR'), hsR = get('HS R'), hsL = get('HS L');
    if (shoulder && hsR && hsL && Math.abs(shoulder - (hsR + hsL)) > 2) notes.push('Half shoulders do not add up to the full shoulder width.');
    return notes;
  }

  // Shows/hides the panel and returns whether it's satisfied (true when not active)
  function refreshCustomPanel() {
    if (!customPanel) return true;
    var active = isCustomSelected();
    customPanel.hidden = !active;
    customPanel.disabled = !active;
    if (!active) {
      if (customError) customError.classList.remove('is-shown');
      return true;
    }

    var done = customMeasureInputs.filter(function (i) { return i.value !== '' && i.checkValidity(); }).length;
    var total = customMeasureInputs.length;
    var measuresFilled = done >= total;

    var profileFilled = customRequired.filter(function (i) { return i.type !== 'radio'; }).every(function (i) { return i.value.trim() !== ''; });

    var ready = measuresFilled && profileFilled && !!(customConsent && customConsent.checked);

    if (customPropSpec) {
      var lines = ['Category: ' + customCategory];
      customMeasureInputs.forEach(function (i) { if (i.value) lines.push(i.dataset.num + '.' + i.dataset.short + '=' + i.value); });
      customPropSpec.value = lines.join(' | ');
    }
    writeSpec();

    if (customError) {
      var notes = customAdvisories();
      if (notes.length) {
        customError.textContent = 'Check: ' + notes[0];
        customError.classList.add('is-shown');
      } else if (!profileFilled) {
        customError.textContent = 'Fill in your fit profile above';
        customError.classList.add('is-shown');
      } else if (!measuresFilled) {
        var left = total - done;
        customError.textContent = left + ' measurement' + (left === 1 ? '' : 's') + ' left';
        customError.classList.add('is-shown');
      } else if (!ready) {
        customError.textContent = 'Tick the confirmation to continue';
        customError.classList.add('is-shown');
      } else {
        customError.classList.remove('is-shown');
      }
    }
    return ready;
  }

  function update() {
    var v = match(selectedOptions());
    if (!v) return;

    if (idInput) idInput.value = v.id;

    if (priceEl) priceEl.textContent = money(v.price);
    if (compareEl) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        compareEl.textContent = money(v.compare_at_price);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    var customReady = refreshCustomPanel();

    if (addBtn && addText) {
      addBtn.disabled = !v.available || !customReady;
      addText.textContent = v.available ? 'Add to cart — ' + money(v.price) : 'Sold out in this size';
    }

    if (stockLine) {
      var qty = v.inventory_quantity;
      if (v.available && v.inventory_management && qty > 0 && qty <= 3) {
        stockLine.textContent = 'Only ' + qty + ' left in ' + v.title;
        stockLine.hidden = false;
      } else {
        stockLine.hidden = true;
      }
    }

    // The made-to-order bridge earns its place only when this size is gone
    if (bridge) bridge.style.display = v.available ? 'none' : 'block';
  }

  root.addEventListener('change', function (e) {
    if (e.target.matches('input[data-option-index]')) update();
    if (e.target === customConsent) update();
    if (e.target.matches('[data-q], [data-prop-simple], [data-prop-radio]')) update();
    if (e.target.dataset.label === 'Preferred fit') updateFitNote();
  });

  root.addEventListener('input', function (e) {
    if (e.target.matches('[data-measure-input], [data-q], [data-prop-simple]')) update();
  });

  // Gallery
  var mainImg = root.querySelector('[data-gallery-main]');
  root.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (thumb && mainImg) {
      mainImg.src = thumb.dataset.full;
      root.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.setAttribute('aria-selected', String(t === thumb));
      });
    }

    // Measurement help text
    var helpBtn = e.target.closest('[data-help]');
    if (helpBtn) {
      var wrap = helpBtn.closest('[data-measure]');
      var open = wrap.classList.toggle('is-open');
      helpBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  });

  // Add to cart without a page reload
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var data = new FormData(form);
      addBtn.disabled = true;
      var original = addText.textContent;
      addText.textContent = 'Adding…';

      fetch('/cart/add.js', { method: 'POST', body: data })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || 'Could not add this jacket.');
          return window.FadCloset.refreshCart();
        })
        .then(function () {
          addText.textContent = 'Added to cart';
          setTimeout(function () {
            addText.textContent = original;
            addBtn.disabled = false;
          }, 1400);
        })
        .catch(function (err) {
          addText.textContent = err.message;
          addBtn.disabled = false;
        });
    });
  }

  // Returning from the measurement guide (?spec=saved) — select Custom sizing so the panel opens pre-filled
  if (new URLSearchParams(window.location.search).get('spec') === 'saved') {
    var allOptions = Array.prototype.slice.call(root.querySelectorAll('input[data-option-index]'));
    var customOption = allOptions.find(function (i) { return i.value.trim().toLowerCase() === 'custom'; });
    if (customOption) customOption.checked = true;
  }

  applySpec();
  updateFitNote();
  update();
})();
